var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privacy-register"},[_c('router-link',{attrs:{"to":"/privacy-policy"}},[_vm._v("Privacy Policy")]),_vm._v(" and "),_c('router-link',{attrs:{"to":"/terms-of-service"}},[_vm._v("Terms of Service")]),_c('p',{staticClass:"copyright"},[_vm._v("Copyright © 2025 D8-CREW")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }